const validFloatRegex = /^[0-9]+[.]?[0-9]*$/;

export { validFloatRegex };
